import React from 'react';

import { Col, Row } from '@/components/grid';
import RichText from '@/components/rich-text';

import { StyledContainer, StyledH3 } from './styles';
import { type HsiycContentBlock } from '@tac/sanity-client/types';

const ContentBlock = ({ heading, body }: HsiycContentBlock) => {
  return (
    <StyledContainer>
      <Row>
        <Col xs={12} lg={8} offset={[0, 0, 0, 1 / 12]}>
          {heading && <StyledH3 as="h2">{heading}</StyledH3>}
          {body && <RichText portableTextValue={body} />}
        </Col>
      </Row>
    </StyledContainer>
  );
};

export default ContentBlock;
